var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2197 4.21967C10.9534 4.48594 10.9292 4.9026 11.1471 5.19621L11.2197 5.28033L17.689 11.75L11.2197 18.2197C10.9534 18.4859 10.9292 18.9026 11.1471 19.1962L11.2197 19.2803C11.4859 19.5466 11.9026 19.5708 12.1962 19.3529L12.2803 19.2803L19.2803 12.2803C19.5466 12.0141 19.5708 11.5974 19.3529 11.3038L19.2803 11.2197L12.2803 4.21967C11.9874 3.92678 11.5126 3.92678 11.2197 4.21967Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21967 4.21967C3.9534 4.48594 3.9292 4.9026 4.14705 5.19621L4.21967 5.28033L10.689 11.75L4.21967 18.2197C3.9534 18.4859 3.9292 18.9026 4.14705 19.1962L4.21967 19.2803C4.48594 19.5466 4.9026 19.5708 5.19621 19.3529L5.28033 19.2803L12.2803 12.2803C12.5466 12.0141 12.5708 11.5974 12.3529 11.3038L12.2803 11.2197L5.28033 4.21967C4.98744 3.92678 4.51256 3.92678 4.21967 4.21967Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLast);
export default __webpack_public_path__ + "static/media/last.6d7b821e18b1db009bccf6fcd3e83ca0.svg";
export { ForwardRef as ReactComponent };